"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openingStore = exports.openingStorePixel = void 0;
var axios_1 = require("axios");
var commonProperties_1 = require("./lib/commonProperties");
var config_1 = require("./config");
var _1 = require(".");
var ENDPOINT_OPENING_STORE = function (baseUrl) { return baseUrl + "/Store/Opening"; };
exports.openingStorePixel = function (StoreId, baseUrl) {
    var _a = config_1.getStatsData(), Platform = _a.Platform, Integration = _a.Integration, Origin = _a.Origin, Provider = _a.Provider;
    var entity = {
        StoreId: StoreId,
        Provider: Provider,
        Origin: Origin,
        Integration: Integration,
        Platform: Platform || _1.Device.Mobile,
        UserToken: commonProperties_1.getUserTokenAMP(),
        ClientTimeStamp: commonProperties_1.getFormattedClientTimeStamp(),
        TimeZoneOffset: commonProperties_1.getTimezoneOffset()
    };
    return ENDPOINT_OPENING_STORE(baseUrl) + "/Pixel?entity=" + JSON.stringify(entity);
};
exports.openingStore = function (StoreId, baseUrl, getCookie, setCookie) {
    var _a = config_1.getStatsData(), Platform = _a.Platform, Integration = _a.Integration;
    var params = {
        StoreId: StoreId,
        Platform: Platform,
        Integration: Integration,
    };
    axios_1.default.post(ENDPOINT_OPENING_STORE(baseUrl), __assign(__assign({}, params), commonProperties_1.default(getCookie, setCookie)));
};
//# sourceMappingURL=opening-store.js.map